export default __webpack_public_path__ + "static/media/broken-clouds-night.d1a05c19.svg";